import React from 'react'
import _ from 'underscore'
import EnquiryLearnerSubjectsPartial from './partial'

class EnquiryLearnerSubjects extends React.Component {

  render() {
    return (
      <div className="learner-subjects">
        {_.map(this.props.learner_subjects, (learner_subject) => {
          const subject = _.first(_.select(this.props.subjects, function(subject) {return subject.id === learner_subject.enquiry_subject_id}))

          return (
            <EnquiryLearnerSubjectsPartial
              key={learner_subject.id}
              learner_subject={learner_subject}
              subject={subject}
              enquiry_id={this.props.enquiry_id}
              country_code={this.props.country_code}
            />
          )
        })}
      </div>
    )
  }
}

export default EnquiryLearnerSubjects
